<template>
    <div class="header-recibo nao-imprimir">
      <h2 class="titulo-pagina">Recibo</h2>
      <div class="botoes">
        <b-button variant="secondary" class="btn-voltar" @click="voltar">
          <i class="bi bi-arrow-left"></i> Voltar
        </b-button>
        
        <b-button
            :variant="isDownloading ? 'success' : 'danger'"
            class="btn-pdf"
            :disabled="isDownloading"
            @click="gerarPDF"
          >
            <i class="bi bi-file-earmark-pdf"></i>
            {{ isDownloading ? 'Baixando' : 'Baixar' }}
        </b-button>

      </div>
    </div>
    <div ref="reciboContent" class="recibo-container print-area">
      <div class="recibo-container">
        <div class="recibo">
          <!-- Cabeçalho do Recibo -->
          <div class="recibo-header">
            <img v-if="$globalState.logoPath" :src="$globalState.logoPath" alt="Logomarca" class="header-logo" />
            <div class="escola-info">
              <h4>{{ escola.nome }}</h4><p></p>
              
              {{ escola.slogan }}<p></p>

              <p>
                  {{ escola.endereco }}, {{ escola.numero }} 
                  <span v-if="escola.complemento && escola.complemento !== 'null'">, {{ escola.complemento }}</span>
                  - {{ escola.bairro }}
              </p>
              <p>{{ escola.municipio }} - {{ escola.estado }}, CEP: {{ escola.cep }}</p>
              <p>
                <i class="bi bi-telephone"></i> {{ escola.telefone }} 
                <i class="bi bi-whatsapp text-success"></i> {{ escola.whatsapp }}
              </p>
          </div>
          </div>
          
          <h3 class="recibo-title">RECIBO - AULA AVULSA</h3>
    
          <!-- Dados do Responsável -->
          <table class="info-table">
            <tbody>
              <tr>
                <td><strong>Responsável:</strong></td>
                <td>{{ recibo.responsavel_nome }}</td>
              </tr>
              <tr>
                <td><strong>Aluno:</strong></td>
                <td>{{ recibo.aluno_nome }}</td>
              </tr>
              <tr>
                <td><strong>Data da Aula:</strong></td>
                <td>
                  <span v-if="recibo.datas_contratadas && recibo.datas_contratadas.length > 0">
                    {{ recibo.datas_contratadas.join(', ') }}
                  </span>
                  <span v-else>Não informada</span>
                </td>
              </tr>
              <tr>
                <td><strong>Turma:</strong></td>
                <td>
                  <ul class="lista-turmas">
                    <li v-for="turma in turmasFormatadas" :key="turma">
                      {{ turma }}
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Texto de recebimento antes da tabela -->
          <p class="recibo-texto">
            Recebemos do responsável acima citado, a importância de <strong> {{ utils.formatarValor(recibo.total_pagar) }}</strong>, referente aos itens descritos abaixo:
          </p>  

    
          <!-- Informações da Aula -->
          <table class="aula-table">
            <thead>
              <tr>
                <th>Código</th>
                <th>Período</th>
                <th>Quantidade</th>
                <th>Valor Unitário</th>
                <th>Desconto (%)</th>
                <th>Valor Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ recibo.id }}</td>
                <td>
                  <span v-if="recibo.datas_contratadas && recibo.datas_contratadas.length > 0">
                    {{ recibo.datas_contratadas.length === 1 
                      ? recibo.datas_contratadas[0]
                      : recibo.datas_contratadas[0] + " a " + recibo.datas_contratadas[recibo.datas_contratadas.length - 1]
                    }}
                  </span>
                  <span v-else>Não informada</span>
                </td>
                <td>{{ recibo.quantidade_aulas }} aula(s)</td>
                <td>{{ utils.formatarValor(recibo.valor_unitario) }}</td>
                <td>{{ formatarPercentual(recibo.desconto) }}</td>
                <td>{{ utils.formatarValor(recibo.total_pagar) }}</td>
              </tr>
            </tbody>
          </table>
    
          <!-- Observações -->
          <div class="observacoes">
            <h4>OBSERVAÇÕES IMPORTANTES:</h4>
            <ol>
              <li>O PAGAMENTO EFETUADO EM CHEQUE(S) E/OU BOLETO(S) SÓ VALIDARÁ O PRESENTE RECIBO APÓS A(S) DEVIDA(S) COMPENSAÇÃO(ÕES).</li>
              <li>ESTE RECIBO SUBSTITUI OUTROS QUE PORVENTURA TENHAM SIDO GERADOS ANTERIORMENTE.</li>
              <li>O NÃO COMPARECIMENTO À AULA MARCADA NÃO DARÁ DIREITO A REEMBOLSO.</li>
              <li>A AULA PODERÁ SER REMARCADA ATÉ O DIA ANTERIOR À SUA REALIZAÇÃO.</li>
            </ol>
          </div>
    
          <!-- Rodapé do Recibo -->
          <div class="assinatura-container">
            <p class="texto-final">
              Por ser verdade, firmamos o presente recibo em 02 (duas) vias de igual teor e conteúdo.
            </p>

            <p class="data-local">
              {{ escola.municipio }} - {{ escola.estado }}, {{ formatarDataAtual() }}
            </p>

            <div class="assinaturas">
              <div class="assinatura">
                <hr />
                <p>{{ escola.nome }}</p>
                <p>CNPJ: {{ formatarCNPJ(escola.cnpj) }}</p>
              </div>

              <div class="assinatura">
                <hr />
                <p>{{ recibo.responsavel_nome }}</p>
                <p>CPF: {{ recibo.cpf_responsavel ? formatarCPF(recibo.cpf_responsavel) : "[CPF não disponível]" }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import { BButton } from "bootstrap-vue-next";
  import jsPDF from "jspdf";
  import html2canvas from "html2canvas";
  import globalUtils from "@/utils/globalUtils.js";

  
  export default {
    components: { 
      BButton  // ✅ Registrar o BButton para ser reconhecido no template
    },
  
    data() {
      return {
        isDownloading: false,
        recibo: {},
        escola: {}
      };
    },

    computed: {
      utils() {
        return globalUtils;
      },
      turmasFormatadas() {
        return this.recibo.turma_info ? this.recibo.turma_info.split(', ') : [];
      }

    },

    methods: {
      async carregarRecibo() {
        const { id } = this.$route.params;
        try {
            // ✅ Buscar todos os dados necessários da aula avulsa em uma única requisição
            const response = await axios.get(`/operacional/aulas-avulsas/${id}/recibo`);

            this.recibo = response.data;

            // ✅ Garantir que datas_contratadas seja um array e formatar as datas corretamente
            this.recibo.datas_contratadas = Array.isArray(this.recibo.datas_contratadas)
                ? this.recibo.datas_contratadas.map(data => this.utils.formatarData(data))
                : [];

            // ✅ Garantir que turma_info seja carregada corretamente
            this.recibo.turma_info = this.recibo.turma_info || "Nenhuma turma contratada.";

            // ✅ Buscar valor unitário da aula avulsa
            const valoresResponse = await axios.get(`/financeiro/valores`);
            if (Array.isArray(valoresResponse.data.data)) {
                const valorAulaAvulsa = valoresResponse.data.data.find(v => v.tipo === "Aula Avulsa");
                this.recibo.valor_unitario = valorAulaAvulsa ? valorAulaAvulsa.valor : "0.00";
            } else {
                console.error("❌ Formato inesperado na API de valores:", valoresResponse.data);
                this.recibo.valor_unitario = "0.00";
            }

            // ✅ Buscar dados da empresa
            const empresaResponse = await axios.get(`configuracoes/empresa`);
            const empresa = empresaResponse.data;

            let municipioNome = "Cidade não informada";
            let estadoSigla = "UF";

            if (empresa.estado_cod) {
                try {
                    const estadosResponse = await axios.get(`/localidades/estados`);
                    const estado = estadosResponse.data.find(e => e.id === empresa.estado_cod);
                    estadoSigla = estado ? estado.sigla : estadoSigla;

                    if (empresa.municipio_cod) {
                        const municipiosResponse = await axios.get(`/localidades/municipios/${empresa.estado_cod}`);
                        const municipio = municipiosResponse.data.find(m => Number(m.id) === Number(empresa.municipio_cod));
                        municipioNome = municipio ? municipio.nome : municipioNome;
                    }
                } catch (error) {
                    console.warn("Erro ao carregar estado e município:", error);
                }
            }

            this.escola = {
                nome: empresa.razao_social || "Nome da Escola",
                cnpj: empresa.cnpj || "00.000.000/0001-00",
                endereco: empresa.endereco || "Endereço não informado",
                numero: empresa.numero || "",
                complemento: empresa.complemento || "",
                bairro: empresa.bairro || "",
                slogan: empresa.slogan || "",
                municipio: municipioNome,
                estado: estadoSigla,
                cep: empresa.cep || "00000-000",
                telefone: empresa.telefone1 || "",
                whatsapp: empresa.whatsapp_url || "",
                instagram: empresa.instagram_url || "",
                facebook: empresa.facebook_url || "",
            };

        } catch (error) {
            console.error("❌ Erro ao carregar recibo:", error);
        }
     },
  
      formatarDataAtual() {
        const hoje = new Date();
        return hoje.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
      },

      formatarCNPJ(cnpj) {
        if (!cnpj) return "";
        return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
      },

      formatarCPF(cpf) {
        if (!cpf) return "";
        return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
      },

      formatarPercentual(valor) {
        return `${Number(valor || 0).toFixed(2).replace(".", ",")}%`;
      },
  
      async gerarPDF() {
          this.isDownloading = true;
          const reciboElement = this.$refs.reciboContent;

          try {
              const canvas = await html2canvas(reciboElement, { 
                  scale: 2,
                  useCORS: true // ✅ Permite capturar imagens externas (logomarca)
              });

              const imgData = canvas.toDataURL("image/png");

              const pdf = new jsPDF("p", "mm", "a4");
              const imgWidth = 210; // Largura do PDF A4
              const imgHeight = (canvas.height * imgWidth) / canvas.width;

              pdf.addImage(imgData, "PNG", 0, 10, imgWidth, imgHeight);
              pdf.save(`recibo-${this.recibo.aluno_nome}.pdf`);

          } catch (error) {
              console.error("Erro ao gerar PDF:", error);
          } finally {
            this.isDownloading = false;
          }
      },


      voltar() {
        this.$router.push("/operacional/aulas-avulsas");
      }
    },
  
    mounted() {
      this.carregarRecibo();
    }
  };
  </script>
    
  <style scoped>
  .recibo-container {
    max-width: 800px;
    margin: auto;
    background: white;
    padding: 20px;
    border: none
  }
  .recibo-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .logo {
    width: 80px;
  }
  .escola-info {
    text-align: center;
    margin: 0; /* Remove as margens verticais */
    line-height: 0; /* ✅ Reduz o espaçamento entre as linhas */
    font-size: 12px; /* ✅ Ajusta o tamanho da fonte */
  } 
  .recibo-title {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 20px;
    font-weight: bold;
  }
  .info-table, .aula-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
  }
  .info-table td, .aula-table th, .aula-table td {
    border: 1px solid #ddd;
    padding: 8px;
  }
  .aula-table th {
    background-color: #f2f2f2;
  }
  .observacoes {
    background: #f8f9fa;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ddd;
    font-size: 14px; /* 🔹 Reduzindo o tamanho da fonte das observações */
    font-weight: normal;
    margin-top: 30px; /* 🔹 Criando espaço entre a tabela e as observações */
  }  
  .observacoes h4 {
    font-size: 14px; /* 🔹 Reduzindo o tamanho do título */
    font-weight: bold;
    margin-bottom: 10px;
  }

  .observacoes ol {
    margin: 0;
    padding-left: 20px;
  }

  .observacoes ul {
    list-style-type: none;
    padding: 0;
  }
  .observacoes li {
    margin-bottom: 4px;
    line-height: 1.5;
    text-transform: uppercase;
    margin-left: 20px;
  }
  .assinatura {
    text-align: center;
    margin-top: 20px;
  }

  .botoes {
    display: flex;
    align-items: center; /* 🔹 Garante que ambos os botões fiquem alinhados verticalmente */
    justify-content: flex-end; /* 🔹 Alinha os botões à direita */
    gap: 10px; /* 🔹 Mantém um espaçamento entre os botões */
  }


  .btn-voltar {
  width: 70px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px; /* 🔹 Reduz o tamanho do texto */
  padding: 4px 8px; /* 🔹 Ajusta o preenchimento para reduzir o tamanho do botão */
  height: 30px; /* 🔹 Define uma altura menor */
}

.btn-pdf {
  width: 70px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px; /* 🔹 Reduz o tamanho do texto */
  padding: 4px 8px; /* 🔹 Ajusta o preenchimento para reduzir o tamanho do botão */
  height: 30px; /* 🔹 Define uma altura menor */
}


  .botoes .btn-imprimir {
  width: 33px;  /* ✅ Mesmo tamanho da altura do botão Voltar */
  height: 33px; /* ✅ Altura igual à largura, tornando-o quadrado */
  padding: 6px;
  border-radius: 6px; /* 🔹 Ajuste se quiser cantos levemente arredondados */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto; /* ✅ Move o botão para a direita */

}

.botoes .btn-imprimir i {
  font-size: 18px; /* Ajuste do ícone dentro do botão */
}

  .header-logo {
  height: 60px;
}

.bi-telephone, .bi-whatsapp {
  margin-right: 2px;
  margin-left: 10px;
}

.recibo-texto {
  font-size: 14px;
  margin-top: 40px;
  margin-bottom: 30px;
}

.assinatura-container {
  text-align: center;
  margin-top: 20px;
}

.texto-final {
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 30px;
  text-align: left;
}

.data-local {
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 15px;
}

.assinaturas {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.assinatura {
  text-align: center;
  width: 45%;
  padding-top: 5px; /* Reduz espaço entre linha e nome */
  font-size: 14px; /* Opcional: reduzir fonte */
  line-height: 0.4; /* 🔹 Reduz espaço entre as linhas */
}

.assinatura hr {
  border: none;
  border-top: 1px solid black;
  margin: 10px auto;
  width: 80%;
}

.header-recibo {
  display: flex;
  justify-content: space-between; /* Alinha o título à esquerda e os botões à direita */
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #ddd; /* Linha separadora */
  margin-bottom: 20px; /* Espaço entre o header e o recibo */
}

.titulo-pagina {
  font-size: 20px;
  font-weight: bold;
  color: #444;
}

.botoes {
  display: flex;
  flex-direction: column; /* 🔹 Botões em coluna (um abaixo do outro) */
  gap: 8px; /* 🔹 Espaço entre os botões */
}


  </style>
  